const THIRD_PARTY_CERTIFIER = 'THIRD_PARTY_CERTIFIER';
const VINEYARD_ADMIN = 'VINEYARD_ADMIN';
const ADMIN = 'admin';
const ROLES = 'roles';

function doesExist(rolesList) {
    return (rolesList !== undefined) && (rolesList !== null);
}

function isAdminOrCertifier() {
    let rolesList = getRoles();
    return doesExist(rolesList) && (rolesList.includes(THIRD_PARTY_CERTIFIER) ||
        rolesList.includes(ADMIN) ||
        rolesList.includes(VINEYARD_ADMIN));
}

function isAdminVineyardAdminOrCertifier() {
    let rolesList = getRoles();
    return ((rolesList !== undefined) && (rolesList !== null)) && (rolesList.includes(THIRD_PARTY_CERTIFIER) ||
        rolesList.includes(ADMIN));
}

function isNotCertifier() {
    return !getRoles().includes(THIRD_PARTY_CERTIFIER);
}

function isAdmin() {
    let rolesList = getRoles();
    if (!rolesList) return false;
    return rolesList.split(',').some(function (r) {
        return r.trim() === ADMIN;
    });
}

function isAdminClass() {
    let roles = getRoles();
    roles.includes(ADMIN) ||
    roles.includes(THIRD_PARTY_CERTIFIER)
    || roles.includes(VINEYARD_ADMIN);
}

function isNonCertifierAdmin() {
    let rolesList = getRoles();
    return ((rolesList !== undefined) && (rolesList !== null)) && !rolesList.includes(THIRD_PARTY_CERTIFIER) &&
        !rolesList.includes(VINEYARD_ADMIN);
}

function isPureAdmin() {
    let rolesList = getRoles();
    return safeGetRole(rolesList).includes(ADMIN);
}

function isVineyardAdminMeth() {
    let rolesList = getRoles();
    return safeGetRole(rolesList).includes(VINEYARD_ADMIN);
}

function getRoles() {
    return localStorage.getItem(ROLES);
}

function isCertifier() {
    return getRoles() !== null &&
        localStorage
            .getItem(ROLES)
            .includes(THIRD_PARTY_CERTIFIER);
}

function isVineyardAdmin() {
    let roles = getRoles();
    return safeGetRole(roles).includes(VINEYARD_ADMIN);
}

function hasViewerRole(rolesList) {
    return safeGetRole(rolesList).includes('VIEWER');
}

function hasAdminRole(rolesList) {
    return safeGetRole(rolesList).includes('admin');
}

function hasVineyardAdminRole(rolesList) {
    return safeGetRole(rolesList).includes('VINEYARD_ADMIN');
}

function safeGetRole(rolesList) {
    return rolesList || [];
}

export {
    doesExist,
    isAdminOrCertifier,
    isAdminVineyardAdminOrCertifier,
    isNotCertifier,
    isAdmin,
    isAdminClass,
    isNonCertifierAdmin,
    isPureAdmin,
    isVineyardAdminMeth,
    getRoles,
    isCertifier,
    isVineyardAdmin,
    hasViewerRole,
    hasAdminRole,
    hasVineyardAdminRole,
    safeGetRole
}
